module.exports = __webpack_public_path__ + "images/檀程长图_03.jpg?v=f50281c4";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan4/檀程长图_03.jpg
 ** module id = 189
 ** module chunks = 1 2
 **/